// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'church-theme-library/components/Image/Image'

class AdvertisementMumsAtTheTable extends React.Component {
	render() {
		return (
			<div className="section-advertisement-general section-advertisement-mums-at-the-table">
				<div className="-inner">
					<div className="-text">
						<h2>Mums At The Table</h2>

						<p>If you're a parent, we invite you to check out Mums At The Table - a place where real women have real conversations about real issues that impact them.</p>

						<p>Find them online and on TV - from motherhood stories to expert advice and healthy recipes, they’ve got your back!</p>

						<p className="with-button">
							<a href="https://www.mumsatthetable.com/" className="button" target="_blank" rel="noopener">Find out more</a>
						</p>
					</div>

					<div className="-image">
						<a href="https://www.mumsatthetable.com/" target="_blank" rel="noopener">
							<Image
								thumb={ `${siteData.images_url}sections/external/mums-at-the-table-b-thumb.jpg` }
								url={ `${siteData.images_url}sections/external/mums-at-the-table-b.jpg` }
								srcset={ null }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
								alt="Mums At The Table"
								width={ 2000 }
								height={ 1200 }
								aspectRatio={ 1 }
							/>
						</a>
					</div>
				</div>
			</div>
		)
	}
}

export default AdvertisementMumsAtTheTable
